const initialState = { registers: [], registerTags: [], registersInstance: [], manufacturerRegisters: [], realtimeFeedsRegisters: [] };

export default (state = initialState, action) => {
  
  switch (action.type){
        case 'REQUEST_REGISTER_TAGS':
          return {
            ...state
          };
        case 'RECEIVE_REGISTER_TAGS':
          return {
            ...state,
            registerTags: action.registerTags
          };
        case 'RECEIVE_REGISTERS_INSTANCE_TAG':
          return {
            ...state,
            registersInstance: action.registers
          };
        case 'RECEIVE_MANUFACTURER_REGISTERS':
          return {
            ...state,
            manufacturerRegisters: action.registers
          };
        case 'RECEIVE_REALTIMEFEEDS_REGISTERS':
          return {
            ...state,
            realtimeFeedsRegisters: action.registers
          };
        default: 
        return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/registers.js